import * as userTokenRequests from "../../api/userTokenRequest";
import {START_LOAD, FINISH_LOAD} from "../reducers/carNumber";
import {push} from "./message";


const startLoading = () => {
    return {type: START_LOAD};
};
const finishLoading = (number) => {
    return {type: FINISH_LOAD, payload: number};
};

export const getBusyCarNumber = (id) => {
    return dispatch => {
        dispatch(startLoading());
        userTokenRequests.getBusyCarNumber(id)
            .then(teams => {
                dispatch(finishLoading(teams))
            })
            .catch(error => {
                dispatch(finishLoading(null));
                dispatch(push(error.message))
            })
    }
};
